import PropTypes from 'prop-types';
import React from 'react';

const PhoneViewField = ({ formData: phoneNumber = '', name }) => {
  const midBreakpoint = -7;
  const lastPhoneString = phoneNumber.slice(-4);
  const middlePhoneString = phoneNumber.slice(midBreakpoint, -4);
  const firstPhoneString = phoneNumber.slice(0, midBreakpoint);

  const phoneString = `${firstPhoneString}-${middlePhoneString}-${lastPhoneString}`;
  return (
    <p>
      <strong>{name}</strong>:{' '}
      {phoneNumber.trim().length > 0 ? phoneString : ''}
    </p>
  );
};

PhoneViewField.propTypes = {
  formData: PropTypes.string,
  name: PropTypes.string,
};

const EmailViewField = ({ formData, name }) => (
  <p>
    <strong>{name}</strong>: {formData || ''}
  </p>
);

EmailViewField.propTypes = {
  formData: PropTypes.string,
  name: PropTypes.string,
};

export const phoneEmailViewField = ({ formData }) => {
  const { primaryPhone, emailAddress } = formData;
  return (
    <div>
      <PhoneViewField formData={primaryPhone} name="Primary phone" />
      <EmailViewField formData={emailAddress} name="Email address" />
    </div>
  );
};

phoneEmailViewField.propTypes = {
  formData: PropTypes.shape({
    primaryPhone: PropTypes.string,
    emailAddress: PropTypes.string,
  }),
};

export default phoneEmailViewField;
